export type CuratedReview = {
  id: string;
  name: string;
  role: string;
  rating: number;
  title: string;
  comment: string;
  date: string;
};

export const CURATED_REVIEWS: CuratedReview[] = [
  {
    id: '1',
    name: 'Sarah M.',
    role: 'Parent of a 7-year-old',
    rating: 5,
    title: 'Morning routine actually gets used',
    comment:
      'Our son is mostly nonverbal. We tried bigger AAC apps and they were just too much on day one. Azalea morning routine is what stuck, bathroom, brush teeth, water, right there. I added a photo of his real backpack and he taps it every school morning without us prompting.',
    date: 'May 2026',
  },
  {
    id: '2',
    name: 'James T.',
    role: 'Dad',
    rating: 4,
    title: 'Good for home, took a minute to set up',
    comment:
      'My daughter is 12 and did not want cartoon emoji faces anymore. Teen mode feels more respectful. Custom buttons took us an evening to get right, but now she says "I need space" instead of shutting down completely. Play Zone is not her thing. The talking part is why we keep it.',
    date: 'April 2026',
  },
  {
    id: '3',
    name: 'Linda K.',
    role: 'Grandmother',
    rating: 5,
    title: 'Even I figured it out',
    comment:
      'I am not great with technology. My daughter helped me add pictures of my house and our dog. My grandson taps "I want Nana" and that is pretty much it for me. No account, works offline when we travel.',
    date: 'March 2026',
  },
  {
    id: '4',
    name: 'Marcus R.',
    role: 'SLP assistant',
    rating: 5,
    title: 'Honest starter for families',
    comment:
      'I point families here when they need something to try before a $250 device. Offline voices, fewer choices mode, real everyday phrases. Not for every kid, but a fair place to start and see if picture AAC clicks.',
    date: 'February 2026',
  },
  {
    id: '5',
    name: 'Priya S.',
    role: 'Mom of two',
    rating: 5,
    title: 'Same app, two ages',
    comment:
      'One kid, one teen. Same app, different look. That sold me. Teen feelings use portrait photos, not clip art, which my older one will actually tolerate. Younger one lives in food and play zone.',
    date: 'January 2026',
  },
  {
    id: '6',
    name: 'Daniel W.',
    role: 'Parent',
    rating: 4,
    title: 'First AAC he opens on his own',
    comment:
      'Sentence builder works well for snack requests. I would like a few more built-in categories over time. Still the first AAC app my kid opens without us forcing it, so that counts for a lot in our house.',
    date: 'December 2025',
  },
  {
    id: '7',
    name: 'Amy C.',
    role: 'Foster parent',
    rating: 5,
    title: 'Bedtime helped us a lot',
    comment:
      'Bedtime routine helps him wind down. "I need the bathroom" before meltdown mode kicks in has saved us more than once. Parent PIN means I can change settings without him switching voices to joke ones.',
    date: 'November 2025',
  },
];

export function averageCuratedRating(reviews: CuratedReview[]): number {
  if (reviews.length === 0) return 0;
  const sum = reviews.reduce((total, review) => total + review.rating, 0);
  return Math.round((sum / reviews.length) * 10) / 10;
}
